import { zonedTimeToUtc } from 'date-fns-tz'
import { add } from 'date-fns'

const format = (date) => {
    return `${date.toISOString().substring(0, 10)} ${date
        .toISOString()
        .substring(11, 19)}`
}

export const buildDateParams = (from, to) => {
    const fromWithOffset = zonedTimeToUtc(from, 'Asia/Jerusalem')
    const toWithOffset = add(zonedTimeToUtc(to, 'Asia/Jerusalem'), {
        hours: 24,
    })

    return {
        from: format(fromWithOffset),
        to: format(toWithOffset),
    }
}
